import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});
export const fetchBacaan = async (page = 1, per_page = 10, filters = {}) => {
  try {
    const params = new URLSearchParams();

    // Add pagination parameters to the URL
    params.append('page', page);
    params.append('per_page', per_page);

    if (filters.jenis_soal_id) {
      params.append('jenis_soal_id', filters.jenis_soal_id);
    }
    if (filters.id_jenis_seleksi) {
      params.append('id_jenis_seleksi', filters.id_jenis_seleksi);
    }
      if (filters.id_tipe_konten) {
      params.append('id_tipe_konten', filters.id_tipe_konten);
    }

    if (filters.search) {
      params.append('search', filters.search);
    }

    // Make the GET request to the /soal endpoint with constructed parameters
    const response = await axios.get(`${BASE_URL_BE}/bacaan?${params.toString()}`, {
      headers: getAuthHeaders() // Include authentication headers
    });

    // Return the response data from the API
    return response.data;
  } catch (error) {
    // Handle errors if the API request fails
    console.error("Error fetching soal:", error);
    throw error; // Re-throw the error for handling in the calling component
  }
};


export const createBacaan = async (formData) => {
    try {
      const response = await axios.post(`${BASE_URL_BE}/bacaan`, formData, {
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error creating soal:", error);
      throw error;
    }
  };

// Perbaiki fungsi updateSoal dan deleteSoal
export const updateBacaan = async (idVideo, formData) => {
    try {
      const response = await axios.put(`${BASE_URL_BE}/bacaan/${idVideo}`, formData, {
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error updating soal:", error);
      throw error;
    }
  };
  
  export const deleteBacaan = async (id) => {
    try {
      const response = await axios.delete(`${BASE_URL_BE}/bacaan/${id}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting soal:", error);
      throw error;
    }
  };

export const fetchCategories = async (idJenisSeleksi) => {
  try {
    const response = await axios.get(
      `${BASE_URL_BE}/jenis_soal/paket-with-categories/${idJenisSeleksi}`,
      { headers: getAuthHeaders() }
    );

    if (
      response.data.success &&
      Array.isArray(response.data.data) &&
      response.data.data.length > 0
    ) {
      const paketList = response.data.data;

      // Ambil kategori berdasarkan ID seleksi
      const kategoriTarget = paketList.find(p => String(p.id_jenis_soal) === String(idJenisSeleksi));
      const kategoriObj = kategoriTarget?.categories || {};

      const bidangOptions = [{ id: null, name: 'ALL - Semua Kategori' }];
      for (const id in kategoriObj) {
        bidangOptions.push({ id: parseInt(id, 10), name: kategoriObj[id] });
      }

      return {
        namaSeleksi: kategoriTarget?.nama_seleksi || "Tanpa Nama Seleksi",
        bidangOptions,
        allSeleksi: paketList, // ← Untuk tombol scroll
      };
    } else {
      return {
        namaSeleksi: "Tidak Diketahui",
        bidangOptions: [{ id: null, name: 'ALL - Semua Kategori' }],
        allSeleksi: [],
      };
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
    return {
      namaSeleksi: "Gagal Mengambil",
      bidangOptions: [{ id: null, name: 'ALL - Semua Kategori' }],
      allSeleksi: [],
    };
  }
};

export const fetchPaketBacaan = async (parentID) => {
  try {
    // URL disesuaikan agar hanya menggunakan parentID sebagai path parameter
    const response = await axios.get(
      `${BASE_URL_BE}/materi-bacaan/${parentID}`,
      { headers: getAuthHeaders() }
    );

    const paketList = response?.data?.data?.paket; // Ambil array paket dari respons

    if (response.data.success && Array.isArray(paketList)) {
      return paketList; // Langsung kembalikan array paket
    } else {
      console.warn("fetchPaketBacaan: Tidak ada data paket atau struktur respons tidak valid.", response.data);
      return [];
    }
  } catch (error) {
    console.error("Error fetching paket bacaan:", error);
    return [];
  }
};



export const handleViewFile = async (url) => {
  try {
    const token = getAuthToken();

    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Gagal mengambil file");
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
  } catch (err) {
    console.error("Error membuka file:", err.message);
    alert("Tidak bisa membuka file. Silakan cek login/token Anda.");
  }
};


export const fetchListBacaan = async (params = {}) => {
  try {
    const queryString = new URLSearchParams();

    if (params.page) queryString.append('page', params.page.toString());
    if (params.per_page) queryString.append('per_page', params.per_page.toString());
    if (params.disable_pagination) queryString.append('disable_pagination', 'true');

    if (params.id_jenis_soal) queryString.append('id_jenis_soal', params.id_jenis_soal.toString());
    if (params.id_jenis_seleksi) queryString.append('id_jenis_seleksi', params.id_jenis_seleksi.toString());
    if (params.id_kategori_paket) queryString.append('id_kategori_paket', params.id_kategori_paket.toString());
    if (params.id_tipe_konten) queryString.append('id_tipe_konten', params.id_tipe_konten.toString());

    const response = await axios.get(`${BASE_URL_BE}/bacaan/list?${queryString.toString()}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching bacaan list:', error);
    throw error;
  }
};
